import en from 'ra-language-english';
import es from 'ra-language-spanish';
import fr from 'ra-language-french';
import pt from 'ra-language-portuguese';

export default {en, es, fr, pt};